module.exports = __webpack_public_path__ + "img/1920_leuco_intro_img2.839dc999.png";